import { resolveImageUrl } from "../context/AppSettingsContext";

// Riconosce URL YouTube / Vimeo / file video e restituisce { type, src }
export function parseVideoUrl(url) {
  if (!url) return null;
  const u = url.trim();
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) return { type: "youtube", id: yt[1] };
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { type: "vimeo", id: vm[1] };
  return { type: "file", src: resolveImageUrl(u) };
}

export function embedSrc(v, { background = true } = {}) {
  if (v.type === "youtube") {
    const base = `https://www.youtube.com/embed/${v.id}?playsinline=1&rel=0&modestbranding=1`;
    return background ? `${base}&autoplay=1&mute=1&loop=1&playlist=${v.id}&controls=0` : `${base}&controls=1`;
  }
  if (v.type === "vimeo") {
    const base = `https://player.vimeo.com/video/${v.id}?playsinline=1`;
    return background ? `${base}&autoplay=1&muted=1&loop=1&background=1` : base;
  }
  return v.src;
}

// Player riutilizzabile: background = autoplay muto senza controlli (non interattivo), altrimenti con controlli
export function VideoPlayer({ url, poster, background = true, className = "", testid }) {
  const v = parseVideoUrl(url);
  if (!v) return null;
  if (v.type === "file") {
    return background
      ? <video src={v.src} poster={poster || undefined} autoPlay muted loop playsInline className={className} data-testid={testid} />
      : <video src={v.src} poster={poster || undefined} controls playsInline className={className} data-testid={testid} />;
  }
  return (
    <iframe
      src={embedSrc(v, { background })}
      title="video"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
      allowFullScreen
      className={`${className} ${background ? "pointer-events-none" : ""}`}
      style={{ border: 0 }}
      data-testid={testid}
    />
  );
}
